const TYPES = ({
  loadingFormSearch: 'LOADING_SEARCH_SETTINGS_AUTO_COMMUNICATION_FORM_TOGGLE',
  searchSuccess: 'SEARCH_SETTINGS_AUTO_COMMUNICATION_SUCCESS',
  searchError: 'SEARCH_SETTINGS_AUTO_COMMUNICATION_LIST_ERROR',

  insertItemList: 'MANAGER_SETTINGS_AUTO_COMMUNICATION_SUCCESS_INSERT_LISTING',
  deleteItemList: 'MANAGER_SETTINGS_AUTO_COMMUNICATION_SUCCESS_DELETE_LISTING',

  templateList: 'TEMPLATE_LIST_AUTO_COMMUNICATION',
  templateDetails: 'TEMPLATE_DETAILS_AUTO_COMMUNICATION',

  setDefaultPage: 'SET_SEARCH_SETTINGS_AUTO_COMMUNICATION_DEFAULT_PAGE',
});

export default TYPES;
